import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';
import { useSiteSettings } from '../../context/SiteSettingsContext';

export default function Navbar() {
  const [scrolled, setScrolled]       = useState(false);
  const [menuOpen, setMenuOpen]       = useState(false);
  const [creatorsOpen, setCreatorsOpen] = useState(false);
  const closeTimer = useRef(null);
  const location   = useLocation();
  const { settings } = useSiteSettings();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); setCreatorsOpen(false); }, [location]);

  const openDropdown = () => { clearTimeout(closeTimer.current); setCreatorsOpen(true); };
  const startClose   = () => { closeTimer.current = setTimeout(() => setCreatorsOpen(false), 120); };

  const navCtaText      = settings.nav_cta_text      || 'Start a Campaign';
  const navCreatorBtn   = settings.nav_creator_btn   || 'Join as Creator';

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <img
            src={settings.logo_url_navbar || 'https://image2url.com/r2/default/images/1775432465627-06dd1d27-a797-457b-9762-e0ec8a726811.png'}
            alt={settings.company_name || 'Logo'}
            width={settings.logo_width || '220'}
          />
          <span></span>
        </Link>

        <ul className={styles.links}>
          <li className={styles.dropdownParent} onMouseEnter={openDropdown} onMouseLeave={startClose}>
            <NavLink to="/creators" className={({ isActive }) => isActive ? styles.active : ''}>
              Creators <span className={styles.dropArrow}>▾</span>
            </NavLink>
            {creatorsOpen && <div className={styles.dropBridge} onMouseEnter={openDropdown} onMouseLeave={startClose} />}
            {creatorsOpen && (
              <div className={styles.dropdown} onMouseEnter={openDropdown} onMouseLeave={startClose}>
                <Link to="/creators" className={styles.dropItem} style={{ borderBottom:'1px solid #f0f2f9' }}>
                  <span className={styles.dropIcon}>✦</span>
                  <div>
                    <div className={styles.dropLabel}>All Creators</div>
                    <div className={styles.dropSub}>Browse full marketplace</div>
                  </div>
                </Link>
                <Link to="/creators?platform=youtube" className={styles.dropItem}>
                  <span className={styles.dropIcon} style={{ color:'#FF0000' }}>▶</span>
                  <div>
                    <div className={styles.dropLabel} style={{ color:'#FF0000' }}>YouTube Creators</div>
                    <div className={styles.dropSub}>Subscribers · Avg Views · Reach</div>
                  </div>
                </Link>
                <Link to="/creators?platform=instagram" className={styles.dropItem}>
                  <span className={styles.dropIcon} style={{ color:'#C13584' }}>◈</span>
                  <div>
                    <div className={styles.dropLabel} style={{ color:'#C13584' }}>Instagram Influencers</div>
                    <div className={styles.dropSub}>Followers · Avg Views · Reels</div>
                  </div>
                </Link>
              </div>
            )}
          </li>
          {[
            { label: settings.nav_label_cases    || 'Case Studies', path: '/case-studies' },
            { label: settings.nav_label_services || 'Services',     path: '/services'     },
            { label: settings.nav_label_brands   || 'For Brands',   path: '/for-brands'   },
            { label: settings.nav_label_about    || 'About',        path: '/about'        },
          ].map(l => (
            <li key={l.path}>
              <NavLink to={l.path} className={({ isActive }) => isActive ? styles.active : ''}>{l.label}</NavLink>
            </li>
          ))}
        </ul>

        <div className={styles.actions}>
          <Link to="/join-as-creator" className={styles.creatorBtn}>{navCreatorBtn}</Link>
          <Link to="/contact" className={styles.ctaBtn}>{navCtaText}</Link>
        </div>

        <button className={`${styles.hamburger} ${menuOpen ? styles.open : ''}`} onClick={() => setMenuOpen(v => !v)} aria-label="Toggle menu">
          <span /><span /><span />
        </button>
      </div>

      <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileOpen : ''}`}>
        <div className={styles.mobileSection}>
          <div className={styles.mobileSectionLabel}>Creators</div>
          <NavLink to="/creators"                    className={({ isActive }) => isActive ? styles.mobileActive : ''}>✦ All Creators</NavLink>
          <NavLink to="/creators?platform=youtube"   className={styles.mobileYT}>▶ YouTube Creators</NavLink>
          <NavLink to="/creators?platform=instagram" className={styles.mobileIG}>◈ Instagram Influencers</NavLink>
        </div>
        <div className={styles.mobileDivider} />
        {[
          { label: settings.nav_label_cases    || 'Case Studies', path: '/case-studies' },
          { label: settings.nav_label_services || 'Services',     path: '/services'     },
          { label: settings.nav_label_brands   || 'For Brands',   path: '/for-brands'   },
          { label: settings.nav_label_about    || 'About',        path: '/about'        },
        ].map(l => (
          <NavLink key={l.path} to={l.path} className={({ isActive }) => isActive ? styles.mobileActive : ''}>{l.label}</NavLink>
        ))}
        <div className={styles.mobileDivider} />
        <Link to="/join-as-creator" className={styles.mobileCreator}>🎬 {navCreatorBtn}</Link>
        <Link to="/contact"         className={styles.mobileCta}>{navCtaText} →</Link>
      </div>
    </nav>
  );
}
